import React from 'react';
import { connect } from 'react-redux';
import VConsole from 'vconsole';
import { getWyId } from '../index/server';

import 'antd-mobile/dist/antd-mobile.css';
import '@wywk/rui-mobile/dist/index.css';
import '../assets/styles/app.scss';

import Root from './router';
import remInit from '../utils/rem';
import { getEnv, getUrlParam, isOversea } from '../utils';
import sensors from '@/utils/sensor';

class App extends React.Component<any, any> {
  state: { loginLoading: boolean; ygpWindow?: boolean };
  constructor(props: any) {
    super(props);

    this.state = {
      loginLoading: true,
      ygpWindow: false,
    };
  }

  componentDidMount() {
    // 移动端适配方案
    remInit(375, 16);
    // vconsole 调试, URL上面是否有手动打开的标识
    this.initVConsole(!!parseInt(getUrlParam('__debug__') || '0'));

    const token = getUrlParam('token');
    sessionStorage.setItem('legoToken', token);
    const ygpWindow = getUrlParam('ygpWindow');
    if (ygpWindow) {
      this.setState({
        ygpWindow: true,
      });
    }

    this.initTrack(token);
    const yooUid = getUrlParam('yooUid'); // 鱼助手传过来的wyuid
    const yooCommoncode = getUrlParam('commoncode'); // 鱼助手传过来的commoncode
    const storeType = getUrlParam('storeType'); // 鱼助手传过来的storeType
    console.log('window.location', window.location.href, ygpWindow);

    if (yooCommoncode && yooUid !== 'null') {
      sessionStorage.setItem('yooCommoncode', yooCommoncode);
    }
    if (yooUid && yooUid !== 'null') {
      sessionStorage.setItem('wyuid', yooUid);
    }
    if (storeType && storeType !== 'null') {
      sessionStorage.setItem('storeType', storeType);
    }
  }
  /**
   * 获取网鱼id并登录 & 并登录神策
   * @param {*} sessionId
   */
  initTrack = (sessionId) => {
    try {
      getWyId({
        token: sessionId,
      }).then(
        (wyid) => {
          if (wyid && wyid.data) {
            console.log('getCookie', wyid.data);
            sensors.login(wyid?.data);
            sessionStorage.setItem('wyuid', wyid.data);
          }
        },
        (err) => {
          throw new Error(err);
        },
      );
    } catch (error) {
      console.log('CDP => err', error);
    }
  };

  initVConsole = (isDebugMode: boolean = false) => {
    const env = getEnv();
    if (isDebugMode || env === 'dev' || env === 'test' || env === 'uat') {
      // eslint-disable-next-line
      new VConsole();
    }
  };

  render() {
    return (
      <div
        id="rootBox"
        className="flex flex-column"
        style={this.state.ygpWindow || isOversea() ? { background: 'rgba(0,0,0,0.1)' } : {}}
      >
        {<Root />}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    ...state.App,
  };
};
const mapDispatchToProps = (dispatch) => ({
  ...dispatch.App,
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
